export default __webpack_public_path__ + "static/O0304-a75cd0f419f514285cca646d95f0d8c3.png";